/**
 * `GET /v1/me` and `POST /v1/characters` (one character per account, Q-30).
 */
import { z } from 'zod';
export const CHARACTER_NAME_MIN = 2;
export const CHARACTER_NAME_MAX = 24;
/** 0 Male, 1 Female (Q-38). */
export const BodyType = z.union([z.literal(0), z.literal(1)]);
/** Item net id per paper-doll layer (Q-21), e.g. `{ hair: 3, top: 12 }`. */
export const LookSchema = z.record(z.string().min(1).max(16), z.number().int().min(0).max(65535));
export const CreateCharacterRequestSchema = z.object({
    name: z
        .string()
        .trim()
        .min(CHARACTER_NAME_MIN)
        .max(CHARACTER_NAME_MAX)
        .regex(/^[\p{L}\p{M}' .-]+$/u, 'letters, spaces, apostrophes, dots and hyphens only'),
    body: BodyType,
    look: LookSchema,
});
